<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div>
              <p class="bold dp-inblock h-30px font-23 mb-20">1:1 문의하기</p>
              <a class="float-right layer-close ml-30 pointer" data-dismiss="modal" aria-label="Close">
                <img src="../assets/img/close.png" @click="$emit('close')" alt="close" class="close-btn" />
              </a>

              <p class="font-13">문의 남겨주시면 담당 매니저가 빠른 시간 내에 연락 드리겠습니다.</p>
              <div class="ask-box">
                <ul>
                  <li>
                    <p class="sub-title">이름 <span class="txt-red">*</span></p>
                    <p class="user-input"><input type="text" v-model="name" placeholder="이름을 입력해 주세요." /></p>
                  </li>
                  <li>
                    <p class="sub-title">E-mail <span class="txt-red">*</span></p>
                    <p class="user-input"><input type="text" v-model="email" placeholder="E-mail을 입력해 주세요." /></p>
                  </li>
                  <li>
                    <p class="sub-title">연락처 <span class="txt-red">*</span></p>
                    <p class="user-input"><input type="text" v-model="mobile" placeholder="연락처를 입력해 주세요." /></p>
                  </li>
                  <li>
                    <textarea name="" id="" v-model="qaContents" class="w-100per h-150px" placeholder="문의 내용을 입력해 주세요."></textarea>
                  </li>
                  <li>
                    <input type="checkbox" name="" id="" v-model="isAgree" />
                    <span class="ml-05 mr-10 font-13">
                      <a @click="openModal()" data-toggle="modal" data-target="#hq-agree" class="underline pointer" style="text-decoration: underline !important"
                        >개인정보 수집 및 이용에 동의합니다.</a
                      >
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer txt-center">
            <a class="admin-btn-default btn ml-05 pointer" @click="send()" data-dismiss="modal" aria-label="Close">확인</a>
          </div>
        </div>
      </div>
      <privacy-term-modal v-if="isTermModalOpened" @close="closeModal()"></privacy-term-modal>
    </div>
  </transition>
</template>

<script>
import PrivacyTermModal from "@/components/privacyTermModal.vue";
import { EmailFormatCheck, EmptyCheck } from "@/utils/validation.js";
export default {
  components: {
    PrivacyTermModal,
  },
  data: () => ({
    isTermModalOpened: false, // 개인정보 팝업 on/off
    name: "", // 이름
    email: "", // 이메일
    mobile: "", // 연락처
    qaContents: "", // 문의 내용
    isAgree: false, // 개인정보 수집 동의 여부
  }),

  beforeDestroy() {
    // console.log('메모리 해제')
  },

  methods: {
    // 개인정보 고지 내용 레이어 팝업 열기
    openModal() {
      this.isTermModalOpened = true;
    },

    // 개인정보 고지 내용 레이어 팝업 닫기
    closeModal() {
      this.isTermModalOpened = false;
    },

    // 1:1 문의 송신
    // TODO: 모달이 닫히는거 jquery로 하지말고, emit으로 파라미터 던져서 메인에서 보내버리기
    send(event) {
      if (!EmptyCheck(this.name, "이름을")) {
        return false;
      }

      if (!EmptyCheck(this.email, "이메일을")) {
        return false;
      }

      if (!EmailFormatCheck(this.email)) {
        return false;
      }

      if (!EmptyCheck(this.mobile, "연락처를")) {
        return false;
      }

      if (!EmptyCheck(this.qaContents, "문의 내용을")) {
        return false;
      }

      if (!this.isAgree) {
        alert("개인정보 수집 및 이용에 동의해주세요.");
        return false;
      }

      // TODO: 어드민에서 들어오는 idxItmSugangPageMain 값을 추후에 pageIdx에 넣어줘야함
      var pageIdx = sessionStorage.getItem("pageIdx");
      var params = {
        // idx: pageIdx,
        email: this.email,
        mobile: this.mobile,
        name: this.name,
        qaContents: this.qaContents,
        // sugangName: 't테스트',
      };

      this.axios.post(this.axios.root + this.axios.port + `/user/qa/${pageIdx}`, params).then((res) => {
        // console.log('res', res)
        alert("문의가 완료되었습니다.\n빠른 시일 내에 답변 드리겠습니다.");
        this.$emit("close");
      });

      // this.isTermModalOpened = false
      // this.$emit('close')
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  &.modal-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  &-window {
    border-radius: 4px;
    overflow: hidden;
  }

  &-content {
    padding: 10px 20px;
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.4s;

  .modal-window {
    transition: opacity 0.4s, transform 0.4s;
  }
}

.modal-leave-active {
  transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>
